// Lib
// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { totalEngagementConfig } from '@/lib/analytics/kpis/pinterest/totalEngagement';
import { SIZE_FULL } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
// Components
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerEngagementsConfig: KpiType<typeof MediaViewerKpiLoader, typeof KPIDefault> =
    {
        ...totalEngagementConfig,
        id: 'engagements',
        size: SIZE_FULL,
        tooltip: null,
        loader: MediaViewerKpiLoader
    };
